import React from "react";
import { Link, useLocation } from "react-router-dom";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import PrimoLogo from "@/components/brand/PrimoLogo";
import { useI18n } from "@/context/LanguageContext";
import { ArrowLeft, Settings2 } from "lucide-react";

export default function TopBar() {
  const { t } = useI18n();
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <header
      data-testid="top-bar"
      className="sticky top-0 z-40 bg-[color:var(--bg)]/90 backdrop-blur-md border-b border-[color:var(--border)] no-print"
    >
      {/* Gold gradient hairline — echoes the PDF's header bar */}
      <div
        className="h-1 w-full"
        style={{
          background: "linear-gradient(90deg,#FFC107 0%,#FFA500 100%)",
        }}
      />
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="group">
          <PrimoLogo />
        </Link>

        <nav className="flex items-center gap-2 sm:gap-3">
          {!isHome && (
            <Link
              to="/"
              data-testid="nav-home"
              className="hidden sm:inline-flex items-center gap-2 px-3 py-2 border border-[color:var(--border)] hover:border-[color:var(--border-strong)] text-[color:var(--text)] text-sm rounded transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              {t("app.newSimulation")}
            </Link>
          )}
          <Link
            to="/saved"
            data-testid="nav-saved"
            className="hidden sm:inline-flex items-center gap-2 px-3 py-2 border border-[color:var(--border)] hover:border-[color:var(--border-strong)] text-[color:var(--text)] text-sm rounded transition-colors"
          >
            {t("app.savedSimulations")}
          </Link>
          <Link
            to="/admin/presets"
            data-testid="nav-settings"
            title={t("app.settings")}
            aria-label={t("app.settings")}
            className="inline-flex items-center gap-2 px-3 py-2 border border-[color:var(--border)] hover:border-[color:var(--brand)] hover:text-[color:var(--brand)] text-[color:var(--text)] text-sm rounded transition-colors"
          >
            <Settings2 className="w-4 h-4" />
            <span className="hidden sm:inline">{t("app.settings")}</span>
          </Link>
          <LanguageSwitcher />
        </nav>
      </div>
    </header>
  );
}
